// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1jWPs","ranges":"BmiRanges_ranges__2-tKP"};